/* eslint-disable no-inline-comments */
// @flow
import React from 'react';
import { AppLink } from '@finect/tabular-core/AppLink';
import { getLoginBaseURL } from '@finect/front-utils/getLoginBaseURL';
import { getBaseURL } from '@finect/front-utils/env';
import { OptionCard } from './components';
import { Overlay, Box, Content, Title, Claim, Options, ActionsFooter } from './partials';

type Props = {
  modal?: boolean,
  user: Object,
  backUrl: string
};

export const PlusSubscribeModalContent = ({ modal = true, user, backUrl }: Props) => {
  const paymentUrl = `/servicios/finect-plus/comprar`;

  const buyUrl = user.isLoggedIn
    ? `${paymentUrl}?plan=1`
    : `${getLoginBaseURL()}?next=${getBaseURL() + paymentUrl}?plan=1`;

  return (
    <Overlay modal={modal}>
      <Box>
        <Content plus fullScreen modal={modal}>
          <Claim>
            <Title plus center>
              Explora nuestros planes:
            </Title>
          </Claim>

          <Options plus>
            <OptionCard plus option="free" url={backUrl} />

            <OptionCard plus option="basic" url={buyUrl} />
          </Options>

          {!user.isLoggedIn && (
            <ActionsFooter>
              ¿Ya tienes cuenta con nosotros?
              <br />
              <AppLink href={getLoginBaseURL()}>Inicia sesión</AppLink>
            </ActionsFooter>
          )}
        </Content>
      </Box>
    </Overlay>
  );
};
